<app-auth-layout>
  <div class="cont">
    <img class="logo" src="./assets/images/logo.svg" />
    <form *ngIf="page === 'enter-password'" [formGroup]="form" (ngSubmit)="submit()">
      <app-error
        *ngFor="let error of errors"
        [errcode]="error"
      />
      <h1>Reset password</h1>

      <sync-text-field
        class="reset-code"
        label="Reset code"
        formControlName="resetCode"
        [errorMessage]="getErrorMessage('resetCode')"
      />

      <sync-divider />

      <sync-text-field
        class="new-password"
        label="New password"
        inputType="password"
        formControlName="newPass1"
        [errorMessage]="getErrorMessage('newPass1')"
      />

      <app-complex-password
        [password]="form.controls.newPass1.value">
      </app-complex-password>

      <sync-text-field
        class="confirm-password"
        label="Confirm password"
        inputType="password"
        formControlName="newPass2"
        [errorMessage]="getErrorMessage('newPass2')"
      />

      <sync-button
        nativeType="submit"
        class="reset-password"
        label="Reset password"
        type="filled"
        [isLoading]="spinner"
        [disabled]="!canSubmit"
        buttonWidth="236px"
      />
    </form>

    <ng-container *ngIf="page === '2fa'">
      <app-two-form-factor
        (submitForm)="handleTwoFactor($event)"
      />
    </ng-container>
  </div>
</app-auth-layout>